"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

Object.defineProperty(exports, "__esModule", {
  value: true
});

var React = require("react");

var styled_components_1 = require("styled-components");

var MappingOver_1 = require("./MappingOver");

var styled_1 = require("./styled");

var Children = React.Children;
var RightPad = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    padding-right: 4px;\n"], ["\n    padding-right: 4px;\n"])));
var LeftPad = styled_components_1.default.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    padding-right: 4px;\n"], ["\n    padding-right: 4px;\n"])));
RightPad.displayName = "ReactContainers-RightPad";
LeftPad.displayName = "ReactContainers-LeftPad";

var getContainerToUse = function getContainerToUse(props) {
  if (props.container) {
    return props.container;
  }

  if (props.rAlign) {
    return LeftPad;
  }

  return RightPad;
};

var InlineItems =
/** @class */
function (_super) {
  __extends(InlineItems, _super);

  function InlineItems() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.renderChild = function (child, index) {
      var Container = getContainerToUse(_this.props);
      return React.createElement(Container, {
        key: index
      }, child);
    };

    return _this;
  }

  InlineItems.prototype.render = function () {
    var props = this.props;
    return React.createElement(styled_1.Flex, null, React.createElement(MappingOver_1.MappingOver, {
      collection: Children.toArray(props.children) || []
    }, this.renderChild));
  };

  InlineItems.displayName = "ReactContainers-InlineItems";
  InlineItems.defaultProps = {
    rAlign: false
  };
  return InlineItems;
}(React.PureComponent);

exports.InlineItems = InlineItems;
var templateObject_1, templateObject_2;